import ConfirmModal from "../../../../components/ui/widget/ConfirmModal/ConfirmModal";
import { DELETE_RECORD_CONFIRM_MESSAGE, DELETE_RECORD_CONFIRM_TITLE } from "../constants/facilityDrawer.constants";

interface RecordDeleteConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RecordDeleteConfirm = ({ isOpen, onClose, onConfirm }: RecordDeleteConfirmProps) => (
  <ConfirmModal
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={DELETE_RECORD_CONFIRM_TITLE}
    message={DELETE_RECORD_CONFIRM_MESSAGE}
    confirmText="Delete"
    cancelText="Cancel"
    confirmVariant="destructive"
  />
);

export default RecordDeleteConfirm;
